import config from "@/config"
import http from "@/utils/request"
// 巡检记录 V2
export default{
    record:{
		url: `${config.API_URL}/inspectionDangerV2/record`,
		name: "查询巡检记录V2",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
    add:{
		url: `${config.API_URL}/inspectionDangerV2/`,
		name: "新增巡检记录V2",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    detail:{
		url: `${config.API_URL}/inspectionDangerV2/record/`,
		name: "查询巡检记录详情V2",
		get: async function(id){
			return await http.get(this.url + id + '/');
		}
	},
    update:{
		url: `${config.API_URL}/inspectionDangerV2/record/`,
		name: "修改巡检记录V2",
		patch: async function(id, data){
			return await http.patch(this.url + id + '/', data);
		}
	},
    uploadPhoto:{
		url: `${config.API_URL}/inspectionDangerV2/record/photo`,
		name: "上传巡检记录图片V2",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    deletePhoto:{
		url: `${config.API_URL}/inspectionDangerV2/photo/`,
		name: "删除巡检记录图片V2",
		delete: async function(id){
			return await http.delete(this.url + id + '/');
		}
	},
    deleteRecord:{
		url: `${config.API_URL}/inspectionDangerV2/record/`,
		name: "删除巡检记录V2",
		delete: async function(id){
			return await http.delete(this.url + id + '/');
		}
	},
    danger:{
		url: `${config.API_URL}/inspectionDangerV2/danger`,
		name: "查询隐患记录V2",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
    addDanger:{
		url: `${config.API_URL}/inspectionDangerV2/danger`,
		name: "新增隐患记录V2",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    dangerDetail:{
		url: `${config.API_URL}/inspectionDangerV2/danger/`,
		name: "查询隐患记录详情V2",
		get: async function(id){
			return await http.get(this.url + id);
		}
	},
    updateDanger:{
		url: `${config.API_URL}/inspectionDangerV2/danger/`,
		name: "修改隐患记录V2",
		patch: async function(id, data){
			return await http.patch(this.url + id, data);
		}
	},
    uploadDangerPhoto:{
		url: `${config.API_URL}/inspectionDangerV2/danger/photo`,
		name: "上传隐患记录图片V2",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    deleteDanger:{
		url: `${config.API_URL}/inspectionDangerV2/danger/`,
		name: "删除隐患记录V2",
		delete: async function(id){
			return await http.delete(this.url + id);
		}
	},
}

